export default __webpack_public_path__ + "static/media/edge.7d5fb6e4.svg";